import { Text } from '@wework/dieter-ui'
import React from 'react'
import isToday from 'date-fns/isToday'
import parseISO from 'date-fns/parseISO'
import format from 'date-fns/format'
import { DATE_FORMAT } from '../../constants/date'
import './styles.css'
import StatusTag from '../../components/StatusTag'
import { SpaceStatus } from '../../components/StatusTag'
import PPWKSection from './PPWKSection'
import Commitment from './Commitment'
import Hold from './Hold'
import Availability from './Availability'
import CommitmentData from './CommitmentInformation'

export default function AvailabilityData({
  space,
  border = false,
  containerStyle = {},
}) {
  if (!space || !space.reservable) {
    return null
  }

  const { inventoryData } = space
  if (!inventoryData) {
    return null
  }

  if (Availability == null) {
    return null
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
      }}
    >
      <div style={{ padding: '16px 0' }}>
        <Text style={{ fontWeight: '700', fontSize: 12, width: 72 }}>
          Availability
        </Text>
      </div>
      <div
        style={{
          width: '100%',
        }}
      >
        <Availability space={space} containerStyle={{ marginBottom: 8 }} />
        <PPWKSection
          //@ts-ignore
          space={space}
        />
        <CommitmentData space={space} />
        <Hold //@ts-ignore
          space={space}
        />
      </div>
    </div>
  )
}
